import SchoolLayout from "../../layout/SchoolLayout";
import Pending from "./Pending";

export default function PendingPage() {
  return (<SchoolLayout>
      <Pending />
    </SchoolLayout>
  );
}
